<template>
  <div class="hot" v-if="hots.length > 0 && page === 1">
    <div class="box-b hot-tag">
      <div class="hd">
        <span class="mark">热门文章标签</span>
        <div class="mark-sub" @click="changTab"><i></i><span>换一换</span></div>
      </div>
      <div class="bd">
        <!-- <p>数据加载中......</p> -->
        <ul class="pics-a" v-for="(hot,index) in hots" :key="index" v-show="currentPage === index">
          <li v-for="(item,i) in hot" :key="i">
            <a :href="item.pub_url" target="_blank" @click="countAd(4538)">
              <img :src="item.pic_new" />
              <p>{{item.word}}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "Hot",
    props: {
        propHot: {
            type: Array,
            default: () => ([])
        },
        propP: { //拿取当前页面
            type: Number,
            default: 1,
        }
    },
    data() {
        return {
            hots: [],
            currentPage: 0, //当前的换一换页面
            startNum: 1, //其实tab
            page: 1, //当前页
        }
    },
    methods: {
        //换一换
        changTab() {
            this.countAd(4539)
            this.currentPage = (this.startNum++) % (Number(this.hots.length))
        } 
    },
    watch: {
        propHot(n) {
            let tempList = []
            if(n) {
                for(let i=0; i<Math.ceil(n.length/6); i++){
                    let start = i*6;
                    let end = start+6;
                    tempList.push(n.slice(start,end));
                }
            }
            this.hots = tempList
        },
        propP(n) {
            this.page = n
        }
    }

};
</script>

<style lang="scss" scoped>
.hot {
    .box-b {
        .hd {
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid #eee;
            margin-bottom: 10px;  
            .mark {
                font-size: 16px;
                font-family: 'Microsoft yahei';
                color: #259;
            }        
            .mark-sub {
                margin-right: 20px;
                float: right;
                display: inline;
                cursor: pointer;
                i {
                    display: inline-block;
                    height: 12px;
                    width: 12px;
                    margin: 17px 5px 0 0;
                    background: url(//www1.pcauto.com.cn/20150105/taglist/img/sp_main.png) 0 -199px no-repeat;
                    vertical-align: top;
                }
                span {
                    position: relative;
                    top: 1px;
                }
            }  
        }
        .bd {
            height: 250px;
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    width: 50%;
                    a {
                        color: #000;
                        text-decoration: none;
                        outline: none;
                        img {
                            width: 90%;
                            border: 0;
                            vertical-align: middle;
                        }
                        p {
                            text-align: center;
                            width: 90%;
                            font-size: 14px;
                            margin: 5px 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
